import { useEffect, useState, useContext } from "react";
import { AppLayout } from "../../../layouts/app";
import {
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import { CardsDetails } from "../../../components/cardsDetails";
import { TrackerRelationshipsService } from "../../../services/trackerRelationships";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { FixedSizeGrid } from "react-window";
import { styled } from "@mui/material/styles";
import AutoSizer from "react-virtualized-auto-sizer";

const TIME_UPDATE_INFO_CARDS = 60000;

export const CardsViewAdmin = () => {
  const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);

  const [cardsData, setCardsData] = useState([]);
  const [typeOperationSelected, setTypeOperationSelected] = useState("all");

  const trackerRelationshipService = new TrackerRelationshipsService();
  const [valueXl, setValueXl] = useState(2.4);


  const getCardsView = (typeOperationSelected) => {
    trackerRelationshipService
      .getCardsView(typeOperationSelected)
      .then((response) => {
        setCardsData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
      theme.palette.mode === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&::before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  const handleChange = (event) => {
    setTypeOperationSelected(event.target.value);
    sessionStorage.setItem("valueTypeOperationCards", event.target.value);
  };

  useEffect(() => {
    const breadcrumbsState = [];
    let interval;
    var result = sessionStorage.getItem("valueTypeOperationCards");
    if (result !== null) {
      setTypeOperationSelected(result);
      getCardsView(result);
      var intervalUpatedCards = sessionStorage.getItem("intervalUpatedCards");
      clearInterval(intervalUpatedCards);
      sessionStorage.setItem(
        "intervalUpatedCards",
        interval = setInterval(() => {
          getCardsView(result);
        }, TIME_UPDATE_INFO_CARDS)
      );
    } else {
      getCardsView(typeOperationSelected);
      sessionStorage.setItem(
        "intervalUpatedCards",
        interval = setInterval(() => {
          getCardsView(typeOperationSelected);
        }, TIME_UPDATE_INFO_CARDS)
      );
    }

    setBreadcrumbs(breadcrumbsState);

    return () => {
      clearInterval(interval);
    }
  }, [typeOperationSelected]);

  const handleCloseAppBarAndDrawer = (value) => {
    if (value === true) {
      setValueXl(2);
    } else if (value === false) {
      setValueXl(2.4);
    }
  };

  const gutter = 10;
  let gutterColumns = valueXl === 2 ? 150 : 165;
  const Cell = ({ columnIndex, rowIndex, style, data }) => {
    const { cardsData, columnCount, gutter, newWidth } = data;
    const index = rowIndex * columnCount + columnIndex;
    if (index >= cardsData.length) return null;

    const element = cardsData[index];
    const valueWidthDif = valueXl === 2 ? 100 : 125;
    const _style = {
      ...style,
      top: style.top + (rowIndex * gutter),
      left: style.left + (columnIndex * (newWidth / columnCount - valueWidthDif)),

    };

    return (
      <div style={_style}>
        <CardsDetails element={element} key={element.trackerRelationshipId} sizeXl={valueXl} />
      </div>
    );
  };


  return (
    <AppLayout
      isGridDetails={false}
      isCardsView={true}
      handleClose={handleCloseAppBarAndDrawer}
    >
      <Grid
        container
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Grid item xl={12}>
          <FormControl>
            <FormLabel
              id="controlled-radio-buttons-group"
              style={{ color: "white" }}
              focused={false}
            >
              Tipo de operação
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              defaultValue={
                sessionStorage.getItem("valueTypeOperationCards") === null
                  ? "all"
                  : sessionStorage.getItem("valueTypeOperationCards")
              }
              onChange={handleChange}
            >
              <FormControlLabel
                value="all"
                control={
                  <Radio icon={<BpIcon />} checkedIcon={<BpCheckedIcon />} />
                }
                style={{ color: "white" }}
                label="Todas"
              />
              <FormControlLabel
                value="eggs"
                control={
                  <Radio icon={<BpIcon />} checkedIcon={<BpCheckedIcon />} />
                }
                style={{ color: "white" }}
                label="Ovos"
              />
              <FormControlLabel
                value="chicken"
                control={
                  <Radio icon={<BpIcon />} checkedIcon={<BpCheckedIcon />} />
                }
                style={{ color: "white" }}
                label="Pintos"
              />
              <FormControlLabel
                value="embryo"
                control={
                  <Radio icon={<BpIcon />} checkedIcon={<BpCheckedIcon />} />
                }
                style={{ color: "white" }}
                label="Embriões"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <AutoSizer style={{ paddingTop: "10px", paddingLeft: "20px" }}>
        {({ height, width }) => {

          const columnCount = Math.floor(((width) / (gutterColumns - 20)) / 2);
          const newWidth = width;
          return (
            <FixedSizeGrid
              columnCount={columnCount}
              columnWidth={valueXl === 2 ? 100 : 125}
              height={window.innerHeight - 160}
              rowCount={200}
              rowHeight={valueXl === 2 ? 295 : 330}
              width={width}
              itemData={{
                cardsData,
                columnCount,
                gutter,
                newWidth,
              }}


            >
              {Cell}
            </FixedSizeGrid>
          )
        }}
      </AutoSizer>
    </AppLayout>
  );
};
